export default [
  { label: "Status", value: "status" },
  { label: "Código da nota fiscal", value: "number" },
  { label: "Data de emissão", value: "issued_at" },
  { label: "Ações", value: "actions", className: "w-9" },
];
